var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8352 2.47703C14.2494 2.47703 14.5852 2.81282 14.5852 3.22703V6.40901C14.5852 6.82322 14.2494 7.15901 13.8352 7.15901H10.6532C10.239 7.15901 9.90325 6.82322 9.90325 6.40901C9.90325 5.9948 10.239 5.65901 10.6532 5.65901H12.0246L11.1836 4.81802C9.42622 3.06066 6.57698 3.06066 4.81962 4.81802C4.53385 5.10379 4.2952 5.41752 4.10301 5.74996C3.89569 6.10855 3.43693 6.23119 3.07833 6.02388C2.71973 5.81656 2.59709 5.3578 2.8044 4.9992C3.06147 4.55455 3.37988 4.13644 3.75896 3.75736C6.1021 1.41421 9.90109 1.41421 12.2442 3.75736L13.0852 4.59835V3.22703C13.0852 2.81282 13.421 2.47703 13.8352 2.47703ZM12.9247 9.97662C13.2832 10.184 13.4058 10.6427 13.1985 11.0013C12.9415 11.4458 12.6232 11.8637 12.2442 12.2426C9.90109 14.5858 6.1021 14.5858 3.75896 12.2426L2.91797 11.4017V12.773C2.91797 13.1872 2.58218 13.523 2.16797 13.523C1.75376 13.523 1.41797 13.1872 1.41797 12.773L1.41797 9.59099C1.41797 9.17678 1.75376 8.84099 2.16797 8.84099H5.34995C5.76416 8.84099 6.09995 9.17678 6.09995 9.59099C6.09995 10.0052 5.76416 10.341 5.34995 10.341H3.97863L4.81962 11.182C6.57698 12.9393 9.42622 12.9393 11.1836 11.182C11.4692 10.8963 11.7078 10.5827 11.9 10.2504C12.1073 9.89186 12.5661 9.76927 12.9247 9.97662Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.eabd7118938619f303d87d351e8e5883.svg";
export { ForwardRef as ReactComponent };